// @flow
import ReactDOM from 'react-dom';
import React from 'react';
import MapContainer from './react/MapContainer';

document.querySelectorAll('.map-is-teaser').forEach(($teaser) => {
  const $map = $teaser.querySelector('.map-is-teaser__map');
  const $script = $teaser.querySelector('.map-is-teaser__data');

  if ($script) {
    const data = JSON.parse($script.textContent);
    ReactDOM.render(
        <MapContainer {...data}/>,
        $map,
    );
  }
});
